import { render, staticRenderFns } from "./PerformanceAssessmentDrawer.vue?vue&type=template&id=06bb939e&"
import script from "./PerformanceAssessmentDrawer.vue?vue&type=script&lang=js&"
export * from "./PerformanceAssessmentDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports